module.exports = __webpack_public_path__ + "static/media/10.bfc515c7.svg";